export default function Footer(){
    return(
        <footer className="bg-gradient-to-br from-gray-100 to-gray-100 min-h-96">
            
        </footer>
    )
}